import _ from 'lodash';

export default function hasPluginWithKey(editor, key) {
  return editor && _.some(editor.plugins, p => p.key === key);
}
